var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonOffset64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3408 29.3086H33.9576L35.2659 57.2205H30.0325L31.3408 29.3086Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6493 29.3091C35.058 29.3091 37.0105 24.4276 37.0105 18.406C37.0105 12.3844 35.058 7.50293 32.6493 7.50293C30.2407 7.50293 28.2881 12.3844 28.2881 18.406C28.2881 24.4276 30.2407 29.3091 32.6493 29.3091Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3938 31.0538C33.3758 33.2368 36.9748 37.0695 42.4322 39.6143C47.8896 42.1591 53.1389 42.4525 54.1569 40.2695C55.1748 38.0865 51.5759 34.2539 46.1185 31.7091C40.661 29.1642 35.4117 28.8709 34.3938 31.0538Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6062 31.0538C31.6242 33.2368 28.0252 37.0695 22.5678 39.6143C17.1104 42.1591 11.8611 42.4525 10.8431 40.2695C9.8252 38.0865 13.4241 34.2539 18.8815 31.7091C24.339 29.1642 29.5883 28.8709 30.6062 31.0538Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6492 36.2868C35.5396 36.2868 37.8827 33.9437 37.8827 31.0533C37.8827 28.1629 35.5396 25.8198 32.6492 25.8198C29.7589 25.8198 27.4158 28.1629 27.4158 31.0533C27.4158 33.9437 29.7589 36.2868 32.6492 36.2868Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonOffset64);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonOffset64.ff9c980f725e9f208695b8329120db12.svg";
export { ForwardRef as ReactComponent };